import { motion } from 'framer-motion';

const ServicesOffered = () => {
  const services = [
    {
      icon: 'ri-file-text-line',
      title: 'General Notarizations',
      description: 'Acknowledgments, jurats, and oaths for personal and business documents',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Power of Attorney',
      description: 'Financial and healthcare POA documents notarized with care and precision',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Healthcare Documents',
      description: 'Living wills, advance directives, and medical authorization forms',
    },
    {
      icon: 'ri-file-shield-line',
      title: 'Wills & Trusts',
      description: 'Witness and notarize estate planning documents (non-legal advice)',
    },
    {
      icon: 'ri-file-list-2-line',
      title: 'Affidavits & Declarations',
      description: 'Sworn statements, name changes, and identity verification documents',
    },
    {
      icon: 'ri-building-line',
      title: 'Business Documents',
      description: 'Corporate resolutions, contracts, agreements, and commercial paperwork',
    },
    {
      icon: 'ri-car-line',
      title: 'Vehicle & Title Transfers',
      description: 'Auto titles, bill of sale, and vehicle-related notarizations',
    },
    {
      icon: 'ri-hospital-line',
      title: 'Facility Visits',
      description: 'Hospital, nursing home, jail, and rehab facility notarizations available',
    },
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-heading font-bold text-navy mb-4">
            Notary Services We Provide
          </h2>
          <div className="w-20 h-1 bg-gold mx-auto mb-6"></div>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto font-body">
            From routine acknowledgments to specialized facility visits, we handle a wide range of notarization needs with professionalism and attention to detail
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow"
            >
              <div className="w-14 h-14 bg-teal/10 rounded-full flex items-center justify-center mb-4">
                <i className={`${service.icon} text-teal text-2xl`}></i>
              </div>
              <h3 className="text-xl font-heading font-bold text-navy mb-3">
                {service.title}
              </h3>
              <p className="text-base text-gray-600 font-body leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesOffered;
